type LanguageBadgeProps = {
  code: string;
};

// eslint-disable-next-line react-refresh/only-export-components
function LanguageBadge(props: LanguageBadgeProps) {
  const { code } = props;
  return (
    <span className="badge badge-sm badge-outline pl-1.5! pr-1! pt-px font-mono text-[.6rem]! font-bold tracking-widest opacity-50">
      {code}
    </span>
  );
}

export const LANGUAGES = [
  {
    code: 'ja',
    name: '日本語',
    icon: <LanguageBadge code="JA" />,
  },
  {
    code: 'en',
    name: 'English',
    icon: <LanguageBadge code="EN" />,
  },
  {
    code: 'zh-Hans',
    name: '简体中文',
    icon: <LanguageBadge code="ZH" />,
  },
  {
    code: 'zh-Hant',
    name: '正體中文',
    icon: <LanguageBadge code="ZH" />,
  },
  {
    code: 'ko',
    name: '한국어',
    icon: <LanguageBadge code="KO" />,
  },
  {
    code: 'vi',
    name: 'Tiếng Việt',
    icon: <LanguageBadge code="VI" />,
  },
] as const;

export const supportedLanguageCodes = LANGUAGES.map((lang) => lang.code);

export type LanguageCode = (typeof LANGUAGES)[number]['code'];
